import deviceMenu from '@js/common/deviceMenu.js';
import utmTracking from '@js/common/utmTracking.js';
import initQualifiedTracking from '@js/common/qualifiedTracking.js';
import {
    appendSVGBtn,
    headeraddClass,
    replaceHashLinks,
    slideToggle,
    slideUp,
} from '@js/common/customFunctions.js';

deviceMenu();
utmTracking();
initQualifiedTracking();

const mainHeader = document.querySelector('.main-header');


/**
 * Update AI prompt buttons dynamically with current page URL.
 */
function initAiPromptButtons() {
    const aiButtons = document.querySelectorAll('.mf-ai-button[data-ai-button="true"]');
    if (!aiButtons.length) {
        return;
    }

    const currentPageUrl = window.location.href;

    aiButtons.forEach(button => {
        const rawUrl = button.getAttribute('data-raw-url');
        const promptText = button.getAttribute('data-prompt') || '';

        if (!rawUrl) {
            return;
        }

        let fullPrompt = promptText.trim();
        if (fullPrompt.includes('{url}') || fullPrompt.includes('[url]')) {
            fullPrompt = fullPrompt.replace(/\{url\}|\[url\]/g, currentPageUrl);
        } else if (fullPrompt) {
            fullPrompt = `${fullPrompt} ${currentPageUrl}`;
        } else {
            fullPrompt = currentPageUrl;
        }

        const encodedPrompt = encodeURIComponent(fullPrompt);
        const encodedPageUrl = encodeURIComponent(currentPageUrl);

        let finalUrl = rawUrl;

        if (finalUrl.includes('{prompt}') || finalUrl.includes('{url}')) {
            finalUrl = finalUrl.replace('{prompt}', encodedPrompt).replace('{url}', encodedPageUrl);
        } else {
            try {
                const parsedUrl = new window.URL(rawUrl, window.location.origin);
                const host = parsedUrl.hostname.toLowerCase();

                if (host.includes('chatgpt.com') || host.includes('chat.openai.com')) {
                    const base = host.includes('openai.com') ? 'https://chat.openai.com/' : 'https://chatgpt.com/';
                    finalUrl = `${base}?q=${encodedPrompt}`;
                } else if (host.includes('claude.ai')) {
                    finalUrl = `https://claude.ai/new?q=${encodedPrompt}`;
                } else if (host.includes('perplexity.ai')) {
                    finalUrl = `https://www.perplexity.ai/search/new?q=${encodedPrompt}`;
                } else if (host.includes('google.com')) {
                    if (host.includes('gemini.google.com')) {
                        finalUrl = `https://gemini.google.com/app?q=${encodedPrompt}`;
                    } else {
                        finalUrl = `https://www.google.com/search?udm=50&aep=11&q=${encodedPrompt}`;
                    }
                } else if (host.includes('x.com') || host.includes('twitter.com')) {
                    finalUrl = `https://x.com/i/grok?text=${encodedPrompt}`;
                } else if (finalUrl.includes('?q=') || finalUrl.includes('&q=') || finalUrl.includes('?text=')) {
                    finalUrl = `${finalUrl}${encodedPrompt}`;
                } else {
                    const sep = finalUrl.includes('?') ? '&q=' : '?q=';
                    finalUrl = `${finalUrl.replace(/\/$/, '')}${sep}${encodedPrompt}`;
                }
            } catch {
                finalUrl = `${rawUrl}?q=${encodedPrompt}`;
            }
        }

        button.href = finalUrl;
    });
}

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    /* Process buttons */
    document.querySelectorAll('.btn-link, .btn').forEach(function(element) {
        if (element.querySelector('svg')) {
            return;
        }
        if (element.classList.contains('btn-link') || element.classList.contains('btn')) {
            appendSVGBtn(element, '#icon-btn-arrow', '24', '15');
        }
    });
    /* Process buttons End */

    initAiPromptButtons();

    const announcementBanner = mainHeader.querySelectorAll('.announcement-banner');
    const searchBtn = mainHeader.querySelectorAll('.mht-search-wrap');

    searchBtn.forEach(btnWrap => {
        const btn = btnWrap.querySelector('.mht-search-btn');
        const closeBtn = btnWrap.querySelector('.btn-close');
        const searchOverlay = btnWrap.querySelector('.mht-overlay');

        if (btn) {
            btn.addEventListener('click', function() {
                this.parentNode.classList.add('is-open');
                document.body.classList.add('scroll-fixed');
            });
        }

        function closeSearch(element) {
            const wrapper = element.closest('.mht-search-wrap');
            if (wrapper) {
                wrapper.classList.remove('is-open');
            }
            document.body.classList.remove('scroll-fixed');
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                closeSearch(this);
            });
        }

        if (searchOverlay) {
            searchOverlay.addEventListener('click', function() {
                closeSearch(this);
            });
        }
    });

    if (announcementBanner) {
        announcementBanner.forEach(banner => {
            const closeBtn = banner.querySelector('.icon-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', function() {
                    const banner = this.closest('.announcement-banner');
                    slideUp(banner, 400, () => { // callback after slideUp completes
                        const headerHeight = mainHeader.offsetHeight;

                        if (mainHeader) {
                            mainHeader.style.setProperty('--hasPadding', `${headerHeight}px`);
                        }
                        // const homepageHero = document.querySelector('.homepage-hero-section');
                        // if (homepageHero && mainHeader) {
                        //     homepageHero.style.setProperty('--header-height', `${headerHeight}px`);
                        // }

                    });
                });
            }
        });
    }

    /************************************
	 ******** All Function Start *********
	 ************************************/
    headeraddClass();
    initResponsiveTables();

    /* Menu Link change "#" to "javascript:void(0);" start */
    replaceHashLinks('header.main-header ul.menu > li');
    replaceHashLinks('footer.main-footer ul.menu > li');
    /* Menu Link change "#" to "javascript:void(0);" end */
    /***********************************
	 ******** All Function End **********
	 ************************************/

    // Footer
    const footerLinks = document.querySelectorAll('.main-footer ul.menu > li.menu-item-has-children > a');

    footerLinks.forEach(link => {
        if (!link.querySelector('.down-arrow')) {
            const span = document.createElement('span');
            span.className = 'down-arrow';

            // Wrap the <a> tag and .down-arrow in a new div with class 'menu-item-wrap'
            const menuItemWrap = document.createElement('div');
            menuItemWrap.className = 'menu-item-wrap';
            link.parentNode.insertBefore(menuItemWrap, link);
            menuItemWrap.appendChild(link);
            menuItemWrap.appendChild(span);
        }
    });

    footerLinks.forEach(link => {
        // Add event listener to the down-arrow to toggle the submenu
        const downArrow = link.parentNode.querySelector('.down-arrow');
        if (downArrow) {
            downArrow.addEventListener('click', function(e) {
                e.stopPropagation(); // Prevent the click event from triggering the link's click handler
                const menuItem = link.closest('.menu-item');
                const subMenu = menuItem.querySelector('.sub-menu');

                // Toggle active class and slideUp/slideDown for submenu visibility
                if (subMenu) {
                    menuItem.classList.toggle('is-active');
                    slideToggle(subMenu); // Slide down if active
                }
            });
        }
    });
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/
(function($) {
    /* Tab outline start */
    $(document).on('keyup', 'a, button', function(e) {
        $(this).each(function() {
            if (e.key === 'Tab' || e.keyCode === 9) {
                if (!$(this).parents('nav').length) {
                    $('.menu-focus').removeClass('menu-focus');
                }
                $('.tab-outline').removeClass('tab-outline');
                $(this).addClass('tab-outline');
                if ($(this).parent('li').find('ul').length > 0) {
                    $(this).parent().addClass('menu-focus').siblings().removeClass('menu-focus');
                } else {
                    if (!$(this).parents('.menu-item-has-children').hasClass('menu-focus')) {
                        $('.menu-focus').removeClass('menu-focus');
                    }
                }
            }
        });
    });

    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            $('.is-click').removeClass('is-click');
            $('.is-open').removeClass('is-open');
            $('.scroll-fixed').removeClass('scroll-fixed');
        }
    });

    $(document).on('click', function() {
        $('.tab-outline').removeClass('tab-outline');
        $('.menu-focus').removeClass('menu-focus');
    });
    /* Tab outline end */

    /* Scroll To ID */
    const mainHeader = $('header.main-header');
    $(window).on('load', function() {
        if (window.location.hash) {
            window.scrollTo(0, 0); // reset jump

            setTimeout(() => {
                const mainHeader = $('header.main-header');
                const targetId = window.location.hash.substring(1);
                const targetElement = $('#' + targetId);

                if (targetElement.length) {
                    $('html, body').animate({
                        scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
                    }, 1000);
                }
            }, 50);
        }
    });

    $('a').each(function() {
        const hrefValue = $(this).attr('href');

        // Check if the href starts with '#'
        if (hrefValue && hrefValue.startsWith('#')) {
            // Run your script here
            $(this).on('click', function(event) {
                event.preventDefault();
                const targetId = hrefValue.substring(1);

                const targetElement = $('#' + targetId);
                if (targetElement.length) {
                    $('html, body').animate({
                        scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
                    }, 500);
                }
            });
        }
    });
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */

/**
 * Initializes responsive behavior for HTML tables:
 * - Wraps all <table> elements (excluding those with .no-wrap) in a .wc-table div.
 * - Further wraps them in a .table-wrapper div for layout control.
 * - On mobile viewports (<768px), transforms tables into column-based blocks for better readability.
 * - Reverts to normal tables on larger viewports.
 * - Handles window resizing with debounce to toggle views dynamically.
 */

function initResponsiveTables() {
    // Wrap tables not marked with .no-wrap in a .wc-table div

    function wrapWCtables() {
        document.querySelectorAll('table:not(.no-wrap)').forEach(table => {
            if (table.hasAttribute('style')) {
                return;
            }

            if (table.querySelector(':scope tr[style], :scope td[style], :scope th[style]')) {
                return;
            }

            const wrapper = document.createElement('div');
            wrapper.className = 'wc-table';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    }

    // Wrap .wc-table tables in a .table-wrapper div if not already wrapped
    function wrapTables() {
        document.querySelectorAll('.wc-table table, .post-details-content-section table').forEach(function(table) {
            if (!table.parentElement.classList.contains('table-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    }

    // Build mobile view for a given wrapper
    function buildMobileTableView(wrapper) {
        const table = wrapper.querySelector('table');
        if (!table || wrapper.querySelector('.mobile-table-view')) {
            return;
        }

        const rows = table.querySelectorAll('tbody tr');
        if (rows.length === 0) {
            return;
        }

        const numColumns = rows[0].children.length;
        const columns = Array.from({
            length: numColumns,
        }, () => []);

        rows.forEach((row, rowIndex) => {
            Array.from(row.children).forEach((cell, colIndex) => {
                columns[colIndex].push({
                    isHeader: rowIndex === 0,
                    content: cell.innerHTML.trim(),
                });
            });
        });

        const mobileView = document.createElement('div');
        mobileView.className = 'mobile-table-view';

        columns.forEach((colData) => {
            const colBlock = document.createElement('div');
            colBlock.className = 'column-block';

            colData.forEach((cell) => {
                const div = document.createElement('div');
                div.className = cell.isHeader ? 'column-header' : 'column-cell';
                div.innerHTML = cell.content;
                colBlock.appendChild(div);
            });

            mobileView.appendChild(colBlock);
        });

        table.insertAdjacentElement('afterend', mobileView);
    }

    // Responsive logic: add/remove mobile view based on screen size
    function handleResponsiveTables() {
        wrapTables();

        document.querySelectorAll('.table-wrapper').forEach(wrapper => {
            const isMobile = window.innerWidth < 768;
            const hasMobileView = wrapper.querySelector('.mobile-table-view');

            if (isMobile && !hasMobileView) {
                buildMobileTableView(wrapper);
            }

            if (!isMobile && hasMobileView) {
                wrapper.querySelector('.mobile-table-view').remove();
            }
        });
    }

    // Initialize all responsive table logic
    wrapWCtables();
    handleResponsiveTables();

    // Resize listener with debounce
    window.addEventListener('resize', () => {
        clearTimeout(window._tableResizeTimeout);
        window._tableResizeTimeout = setTimeout(handleResponsiveTables, 200);
    });
};
